import React from "react";
import { Star, Clock } from "lucide-react";

const fmt = (d) => (d ? d.slice(0, 10).split("-").reverse().join("/") : "");

// Saldi del cliente sulle raccolte secondarie (la principale è già il saldo grande della card)
export function CollectionBalances({ collections = [], testid = "public-collections" }) {
  const extra = collections.filter((c) => !c.is_default);
  if (!extra.length) return null;
  return (
    <div className="grid grid-cols-2 gap-2" data-testid={testid}>
      {extra.map((c) => (
        <div key={c.id} className="rounded-2xl p-3 text-zinc-900 relative overflow-hidden" style={{ background: c.color }} data-testid={`collection-balance-${c.id}`}>
          <div className="text-[10px] uppercase tracking-widest font-bold opacity-80 truncate">{c.name}</div>
          <div className="flex items-center gap-1 font-heading font-extrabold text-2xl leading-none mt-1">{c.balance}<Star className="h-4 w-4" fill="currentColor" /></div>
          <div className="text-[10px] mt-1 opacity-80 flex items-center gap-1">
            {c.status === "expired" ? "Raccolta conclusa" : c.expiry?.date ? <><Clock className="h-3 w-3" /> {c.expiry.renew ? `Si rinnova il ${fmt(c.expiry.date)}` : `${c.expiry.points != null ? `${c.expiry.points} pt ` : ""}scadono il ${fmt(c.expiry.date)}`}</> : c.mode === "points_plus_cash" ? "Punti + contributo" : "Solo punti"}
          </div>
        </div>
      ))}
    </div>
  );
}

// Tab per filtrare il catalogo premi per raccolta
export function CollectionTabs({ collections = [], value, onChange, testid = "public-collection-tabs" }) {
  if (collections.length <= 1) return null;
  return (
    <div className="flex gap-2 overflow-x-auto pb-1" data-testid={testid}>
      {collections.map((c) => (
        <button key={c.id} type="button" onClick={() => onChange(c.id)} data-testid={`collection-tab-${c.id}`}
          className={`shrink-0 rounded-full px-3 py-1 text-xs font-semibold ring-1 transition ${value === c.id ? "ring-transparent text-zinc-900" : "ring-zinc-700 text-zinc-300 bg-transparent"}`}
          style={value === c.id ? { background: c.color } : undefined}>
          {c.name} · {c.balance} pt
        </button>
      ))}
    </div>
  );
}
